import { createContext, useCallback, useContext, useMemo, useRef, type ReactNode } from 'react';

type PurchaseTransactionsHubContextValue = {
  registerRefetch: (refetch: () => void) => void;
  refetchList: () => void;
};

const PurchaseTransactionsHubContext = createContext<PurchaseTransactionsHubContextValue | null>(
  null
);

export const PurchaseTransactionsHubProvider = ({ children }: { children: ReactNode }) => {
  const refetchRef = useRef<(() => void) | null>(null);

  const registerRefetch = useCallback((refetch: () => void) => {
    refetchRef.current = refetch;
  }, []);

  const refetchList = useCallback(() => {
    refetchRef.current?.();
  }, []);

  const value = useMemo(
    () => ({ registerRefetch, refetchList }),
    [registerRefetch, refetchList]
  );

  return (
    <PurchaseTransactionsHubContext.Provider value={value}>
      {children}
    </PurchaseTransactionsHubContext.Provider>
  );
};

export const usePurchaseTransactionsHub = () => {
  const context = useContext(PurchaseTransactionsHubContext);
  if (!context) {
    throw new Error(
      'usePurchaseTransactionsHub must be used within PurchaseTransactionsHubProvider'
    );
  }
  return context;
};
